require('./OKRadioSwitch.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

class OKRadioSwitch extends React.Component {
    constructor(props) {
        super(props);

        this.handleOKRadioButtonSwitch = this.handleOKRadioButtonSwitch.bind(this);
    }

    handleOKRadioButtonSwitch(evt) {
        const { onChange } = this.props;
        onChange(evt.target.value);
    }

    render() {
        const { children, className, disabled, id, isChecked, name, value } = this.props;
        const classes = classNames(
            className,
            { 'ok-radio-switch': !className }
        );

        return (
            <div className={classes}>
                <input
                    checked={isChecked}
                    className="ok-radio-switch__switch-input"
                    disabled={disabled}
                    id={id}
                    name={name}
                    onChange={this.handleOKRadioButtonSwitch}
                    type="radio"
                    value={value}
                />
                <label className="ok-radio-switch__switch-label" htmlFor={id}>
                    {children}
                </label>
            </div>
        );
    }
}

OKRadioSwitch.propTypes = {
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    isChecked: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.any.isRequired
};

OKRadioSwitch.defaultProps = {
    className: '',
    disabled: false,
    isChecked: false
};

module.exports = OKRadioSwitch;
